import { getCommonRequestData } from "../utils";
import gatherConcepts from "./concepts";
import axios from "axios";
export * from "./recommended";
export * from "./accessDetails";
export * from "./excludeServiceId"
import { commonConstant } from "../../../../server/triage/constants";
import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../../features/utils";

export async function getTriageScoreFromAnswers(
  { state, actions, setState, lang },
  isComingFromCovidPage
) {
  const { triageRequest } = state;
  const { sessionId } = triageRequest;
  const { locationMeta } = triageRequest;
  const encounterToken = localStorage.getItem("token");
  var moment = require("moment-timezone");
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  var qtCheck = state.QuickTeleMedAvailableOrNot
  if(triageRequest.selectRecentPhysicalInjury === true) {    
    qtCheck = false
  }
  const data = {
    identifier: sessionId,
    Token: encounterToken,
    LanguageId: actions.getLanguage(lang),
    Unit: "Km",
    Time: moment()
      .tz(locationMeta.country + "/" + locationMeta.city)
      .format(),
    Radius: 40,
    Translate: false,
    LanguageTo: "de",
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
    IsQuickTelemedicine : qtCheck,
    TriageLog : qtCheck ? state.triageRequest.triageLogResponse : "",
  };
  console.log("Este es el data");
  console.log(data);

  const success = await actions.sendTriageRequest({
    action: "getScoreFromAnswers",
    data,
  });

  if (success && success.message === commonConstant.success) {
    return await actions.getServiceIdList();
  } 
}
